import {SearchResultInterface} from '@shared/interfaces/search.interface';

export abstract class AbstractSearchResultComponent {
    public abstract setData(data: SearchResultInterface): void;
}
